module.exports = __webpack_public_path__ + "img/circle-table-3.a8192604.png";